import React, {useState, useEffect} from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Header from './components/Header';
import Login from './components/Login';
import './index.css';
import Home from './views/home/home';

import Remove1 from './views/remove/Remove1';
import Remove2 from './views/remove/Remove2';
import Remove3 from './views/remove/Remove3';

import Replace1 from './views/replace/Replace1';
import Replace2 from './views/replace/Replace2';
import Replace3 from './views/replace/Replace3';

import Works from './views/works/Works';
import ViewWork from './views/works/ViewWork';

import Lists from './views/lists/Lists';

import Add1 from './views/add/Add1';
import Add2 from './views/add/Add2';
import Add3 from './views/add/Add3';

function App() {
    const [token, setToken] = useState(null);
    const [username, setUsername] = useState(null);
    const [loading, setLoading] = useState(true);

    const handleLogout = () => {
        localStorage.removeItem('apiToken');
        localStorage.removeItem('username');
        setToken(null);
        setUsername(null);
    };

    useEffect(() => {
        (async () => {
            const params = new URLSearchParams(window.location.search);
            const urlToken = params.get('token');
            const urlUser = params.get('username');

            if (urlToken) {
                // save token and optional username from URL
                localStorage.setItem('apiToken', urlToken);
                setToken(urlToken);
                if (urlUser) {
                    localStorage.setItem('username', urlUser);
                    setUsername(urlUser);
                } else {
                    // try loading stored username if none provided
                    const stored = localStorage.getItem('username');
                    if (stored) setUsername(stored);
                }
                // clean up URL
                const basePath = window.location.pathname;
                window.history.replaceState({}, '', basePath);
                setLoading(false);
                return;
            }

            // No URL token: fallback to localStorage
            const savedToken = localStorage.getItem('apiToken');
            const savedUser = localStorage.getItem('username');
            if (savedToken) setToken(savedToken);
            if (savedUser) setUsername(savedUser);
            setLoading(false);
        })();
    }, []);

    if (loading) {
        return <div className="text-center mt-24">Laen...</div>;
    }

    if (!token) {
        return <Login onLogin={(tok) => {
            setToken(tok);
            // Username is already set by Login component in localStorage
            const savedUser = localStorage.getItem('username');
            setUsername(savedUser);
        }} />;
    }

    return (
        <Router>
            <div className="App">
                <Header username={username} onLogout={handleLogout} />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/remove1" element={<Remove1 />} />
                    <Route path="/remove2" element={<Remove2 />} />
                    <Route path="/remove3" element={<Remove3 />} />
                    <Route path="/replace1" element={<Replace1 />} />
                    <Route path="/replace2" element={<Replace2 />} />
                    <Route path="/replace3" element={<Replace3 />} />
                    <Route path="/lists" element={<Lists />} />
                    <Route path="/works" element={<Works currentUser={username} />} />
                    <Route path="/ViewWork" element={<ViewWork />} />
                    <Route path="/add1" element={<Add1 />} />
                    <Route path="/add2" element={<Add2 />} />
                    <Route path="/add3" element={<Add3 />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
